export enum FaultTypeEnum {
    CID = 'CID',
    DAMAGE = 'Damage',
    DEFECTIVE = 'Defective'
}
